export default __webpack_public_path__ + "ad34b8e547dc8f4cf692b24f498c30ce.svg";